import { render } from "./ModalAddFranchisee.vue?vue&type=template&id=72cc3f2c&scoped=true"
import script from "./ModalAddFranchisee.vue?vue&type=script&lang=js"
export * from "./ModalAddFranchisee.vue?vue&type=script&lang=js"

import "./ModalAddFranchisee.vue?vue&type=style&index=0&id=72cc3f2c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72cc3f2c"]])

export default __exports__